"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateMonthlyPayment = void 0;
const calculateMonthlyPayment = (principal, rate, years) => {
    if (rate === null || rate === undefined || rate === 0) {
        return 'N/A';
    }
    const monthlyRate = rate / 100 / 12;
    const numberOfPayments = years * 12;
    // return only 2 decimal places
    return Number(((principal *
        monthlyRate *
        Math.pow(1 + monthlyRate, numberOfPayments)) /
        (Math.pow(1 + monthlyRate, numberOfPayments) - 1)).toFixed(2));
};
exports.calculateMonthlyPayment = calculateMonthlyPayment;
